import React from 'react'
import Base from './Base'

export default function App() {
  return (
    <div className="position-relative minh-600px">
      <Base />
    </div>
  )
}
